import { createFileRoute } from "@tanstack/react-router";
import Analytics from "../Screens/Analytics";

export const Route = createFileRoute("/analytics")({
  component: RouteComponent,
});

function RouteComponent() {
  return <Analytics />;
}
